<div class="animated fadeIn">
  <tabset>

    <!-- ===== TAB MISSIONS ===== -->
    <tab heading="Missions" (selectTab)="onSelectMissionsTab()">
      <!-- Filters -->
      <div class="card mt-3">
        <div class="card-header" (click)="missionsIsFilterOpen = !missionsIsFilterOpen" style="cursor:pointer">
          <i class="fa fa-filter"></i> Filtres
          <div class="pull-right">
            @if (missionsIsFilterOpen) {
              <i class="fa fa-chevron-down"></i>
            } @else {
              <i class="fa fa-chevron-left"></i>
            }
          </div>
        </div>
        <div class="card-body" [collapse]="!missionsIsFilterOpen">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Start Date (min)</label>
                <input class="form-control" type="date" [(ngModel)]="missionsStartDateMinFilter">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Start Date (max)</label>
                <input class="form-control" type="date" [(ngModel)]="missionsStartDateMaxFilter">
              </div>
            </div>
          </div>
          <div class="filters-buttons">
            <button [disabled]="missionsIsLoading" class="btn btn-sm btn-primary" (click)="onClickMissionsFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button [disabled]="missionsIsLoading" class="btn btn-sm btn-danger" (click)="onClickMissionsResetFilters()"><i class="fa fa-ban"></i> Reset</button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card mt-3">
        <div class="card-header">
          <i class="fa fa-flag"></i> Missions
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary me-2" type="button" (click)="onClickAddMission()">
              <i class="fa fa-plus"></i> Add Mission
            </button>
            <button class="btn btn-sm btn-success" type="button" (click)="onClickAddMissionsFromFile()" [disabled]="missionsIsLoading">
              <i class="fa fa-upload"></i> Import from file
            </button>
            <input #missionsFileInput type="file" accept=".xlsx,.xls" style="display:none" (change)="onMissionsFileSelected($event)">
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Complete Qty</th>
                <th>Points Reward</th>
                <th>Custom Param</th>
                <th>Users</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (missionsIsLoading) {
                <tr>
                  <td colspan="10" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else {
                @for (mission of missions; track mission.missionId; let i = $index) {
                  <tr>
                    <td>{{ (missionsPageNumber - 1) * missionsResultsPerPage + i + 1 }}</td>
                    <td>{{ mission.missionId }}</td>
                    <td>{{ getMissionTypeName(mission.type) }}</td>
                    <td>{{ dateService.getDateFromatted(mission.startDateTimestamp) }}</td>
                    <td>{{ dateService.getDateFromatted(mission.endDateTimestamp) }}</td>
                    <td>{{ mission.completeQuantity }}</td>
                    <td>{{ mission.pointsReward }}</td>
                    <td>{{ mission.customParam }}</td>
                    <td>{{ mission.usersCount }}</td>
                    <td>
                      <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickMissionUsers(mission)" tooltip="Users" placement="top"><i class="fa fa-users"></i></button>
                      <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEditMission(mission)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteMission(mission)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (missionsPageNumber - 1) * missionsResultsPerPage + 1 }} to {{ (missionsPageNumber - 1) * missionsResultsPerPage + missions.length }} of {{ missionsTotalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="missionsPageNumber <= 1">
                <button class="page-link" (click)="onMissionsPaginationPrevious()" [disabled]="missionsPageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(missionsPageNumber, missionsTotalPages); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === missionsPageNumber">
                    <button class="page-link" (click)="missionsGoToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="missionsPageNumber >= missionsTotalPages">
                <button class="page-link" (click)="onMissionsPaginationNext()" [disabled]="missionsPageNumber >= missionsTotalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </tab>

    <!-- ===== TAB MISSION REWARDS ===== -->
    <tab heading="Mission Rewards" (selectTab)="onSelectRewardsTab()">
      <!-- Filters -->
      <div class="card mt-3">
        <div class="card-header" (click)="rewardsIsFilterOpen = !rewardsIsFilterOpen" style="cursor:pointer">
          <i class="fa fa-filter"></i> Filtres
          <div class="pull-right">
            @if (rewardsIsFilterOpen) {
              <i class="fa fa-chevron-down"></i>
            } @else {
              <i class="fa fa-chevron-left"></i>
            }
          </div>
        </div>
        <div class="card-body" [collapse]="!rewardsIsFilterOpen">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Start Date (min)</label>
                <input class="form-control" type="date" [(ngModel)]="rewardsStartDateMinFilter">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label>Start Date (max)</label>
                <input class="form-control" type="date" [(ngModel)]="rewardsStartDateMaxFilter">
              </div>
            </div>
          </div>
          <div class="filters-buttons">
            <button [disabled]="rewardsIsLoading" class="btn btn-sm btn-primary" (click)="onClickRewardsFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button [disabled]="rewardsIsLoading" class="btn btn-sm btn-danger" (click)="onClickRewardsResetFilters()"><i class="fa fa-ban"></i> Reset</button>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card mt-3">
        <div class="card-header">
          <i class="fa fa-gift"></i> Mission Rewards
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary me-2" type="button" (click)="onClickAddMissionReward()">
              <i class="fa fa-plus"></i> Add Mission Reward
            </button>
            <button class="btn btn-sm btn-success" type="button" (click)="onClickAddMissionsRewardsFromFile()" [disabled]="rewardsIsLoading">
              <i class="fa fa-upload"></i> Import from file
            </button>
            <input #rewardsFileInput type="file" accept=".xlsx,.xls" style="display:none" (change)="onRewardsFileSelected($event)">
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Currency Type</th>
                <th>Currency Qty</th>
                <th>Points Required</th>
                <th>Points Required Total</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (rewardsIsLoading) {
                <tr>
                  <td colspan="9" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else {
                @for (reward of missionRewards; track reward.missionRewardId; let i = $index) {
                  <tr>
                    <td>{{ (rewardsPageNumber - 1) * rewardsResultsPerPage + i + 1 }}</td>
                    <td>{{ reward.missionRewardId }}</td>
                    <td>{{ dateService.getDateFromatted(reward.startDateTimestamp) }}</td>
                    <td>{{ dateService.getDateFromatted(reward.endDateTimestamp) }}</td>
                    <td>{{ getCurrencyTypeDisplay(reward) }}</td>
                    <td>{{ reward.currencyQuantity }}</td>
                    <td>{{ reward.pointsRequired }}</td>
                    <td>{{ reward.pointsRequiredTotal }}</td>
                    <td>
                      <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEditMissionReward(reward)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                      <span class="text-muted mx-1">|</span>
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteMissionReward(reward)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (rewardsPageNumber - 1) * rewardsResultsPerPage + 1 }} to {{ (rewardsPageNumber - 1) * rewardsResultsPerPage + missionRewards.length }} of {{ rewardsTotalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="rewardsPageNumber <= 1">
                <button class="page-link" (click)="onRewardsPaginationPrevious()" [disabled]="rewardsPageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(rewardsPageNumber, rewardsTotalPages); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === rewardsPageNumber">
                    <button class="page-link" (click)="rewardsGoToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="rewardsPageNumber >= rewardsTotalPages">
                <button class="page-link" (click)="onRewardsPaginationNext()" [disabled]="rewardsPageNumber >= rewardsTotalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </tab>

    <!-- ===== TAB CONFIGURATIONS ===== -->
    <tab heading="Configurations">
      <app-configurations-block [configurations]="missionsConfigurations" [collapsible]="false" />
    </tab>

  </tabset>
</div>

<app-mission-add-modal #missionAddModal></app-mission-add-modal>
<app-mission-edit-modal #missionEditModal></app-mission-edit-modal>
<app-mission-users-modal #missionUsersModal></app-mission-users-modal>
<app-mission-reward-add-modal #missionRewardAddModal></app-mission-reward-add-modal>
<app-mission-reward-edit-modal #missionRewardEditModal></app-mission-reward-edit-modal>
